import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { 
  Star, 
  MapPin, 
  Phone, 
  Shield, 
  Clock,
  Luggage,
  Users,
  Plane,
  Wifi,
  Coffee,
  Battery,
  Wind
} from 'lucide-react';
import { IoAirplaneOutline } from 'react-icons/io5';
import { MdOutlineFlight, MdOutlineLocalTaxi } from 'react-icons/md';
import { FaWhatsapp } from 'react-icons/fa';

// Import vehicle images
// import sedan from "../../assets/image.png";
// import ertiga from "../../assets/image.png";
import crysta from "../../assets/image.png";
import hycross from "../../assets/image.png";
import fortuner from "../../assets/image.png";
import tempo from "../../assets/image.png";
import bus from "../../assets/image.png";
// import city from "../../assets/image.png";



const sedan ="https://static.caronphone.com/public/brands/21/493/2518/2518_1731400393.webp"
const city=    "https://c4.wallpaperflare.com/wallpaper/614/644/854/2019-corolla-gli-toyota-wallpaper-thumb.jpg"
const ertiga ="https://imgd.aeplcdn.com/664x374/n/c6es93a_1572125.jpg?q=80"

const Y = "#28aa96";
const YD = "#020202";
const YL = "#FFF9E6";
const font = "'Nunito', sans-serif";

const AIRPORT_VEHICLES = [
  { 
    id: 1, 
    image: "sedan", 
    name: "Swift Dzire", 
    models: "Swift Dzire, Etios", 
    type: "Economy", 
    seaters: "4", 
    bags: 2, 
    price: "₹700", 
    HourPrice: "2 Hrs/20 Kms",
    tag: "Most Booked", 
    badge: "popular", 
    rating: 4.8, 
    features: ["Flight Tracking", "Meet & Greet", "60 mins waiting"],
    ac: true,
    music: true,
    charger: true
  },
  { 
    id: 2, 
    image: "premiumSedan", 
    name: "Toyota Etios", 
    models: "Toyota Etios", 
    type: "Comfort", 
    seaters: "4", 
    bags: 2, 
    price: "₹900", 
    HourPrice: "3 Hrs/50 kms",
    tag: "Value Pick", 
    badge: "value", 
    rating: 4.7, 
    features: ["Extra Legroom", "Premium Interior", "USB Charging"],
    ac: true,
    music: true,
    charger: true
  },
  // { 
  //   id: 3, 
  //   image: "ertiga", 
  //   name: "Maruti Ertiga", 
  //   models: "Ertiga", 
  //   type: "Family", 
  //   seaters: "6", 
  //   bags: 4, 
  //   price: "₹1,599", 
  //   HourPrice: "3 Hrs/50 kms",
  //   tag: null, 
  //   badge: null, 
  //   rating: 4.7, 
  //   features: ["Extra Luggage", "Family Comfort", "3 Rows"],
  //   ac: true,
  //   music: true,
  //   charger: true
  // },
//   { 
//     id: 4, 
//     image: "crysta", 
//     name: "Innova Crysta", 
//     models: "Toyota Innova Crysta", 
//     type: "Premium", 
//     seaters: "7", 
//     bags: 5, 
//     price: "₹1,999", 
//     tag: "Premium", 
//     badge: "top", 
//     rating: 4.9, 
//     features: ["Luxury Interior", "Captain Seats", "Premium AC"],
//     ac: true,
//     music: true,
//     charger: true,
//     wifi: true
//   },
//   { 
//     id: 5, 
//     image: "hycross", 
//     name: "Innova Hycross", 
//     models: "Toyota Innova Hycross", 
//     type: "Luxury", 
//     seaters: "7", 
//     bags: 5, 
//     price: "₹2,299", 
//     tag: "Luxury", 
//     badge: "top", 
//     rating: 5.0, 
//     features: ["Hybrid Engine", "Panoramic Roof", "ADAS Safety"],
//     ac: true,
//     music: true,
//     charger: true,
//     wifi: true
//   },
//   { 
//     id: 6, 
//     image: "fortuner", 
//     name: "Fortuner", 
//     models: "Toyota Fortuner", 
//     type: "Premium SUV", 
//     seaters: "7", 
//     bags: 5, 
//     price: "₹4,000", 
//     tag: "Luxury", 
//     badge: "top", 
//     rating: 4.8, 
//     features: ["Luxury Interior", "Powerful Engine", "Premium Sound"],
//     ac: true,
//     music: true,
//     charger: true,
//     wifi: true
//   },
//   { 
//     id: 7, 
//     image: "tempo", 
//     name: "Tempo Traveller", 
//     models: "12 Seater", 
//     type: "Group", 
//     seaters: "12", 
//     bags: 8, 
//     price: "₹4,500", 
//     tag: "Group", 
//     badge: "value", 
//     rating: 4.7, 
//     features: ["Extra Luggage", "Group Travel", "Pushback Seats"],
//     ac: true,
//     music: true,
//     charger: true
//   },
//   { 
//     id: 8, 
//     image: "bus", 
//     name: "Bus", 
//     models: "21-50 Seater", 
//     type: "Large Group", 
//     seaters: "50", 
//     bags: 20, 
//     price: "₹8,500", 
//     tag: "Group", 
//     badge: null, 
//     rating: 4.5, 
//     features: ["Luggage Bay", "Events & Tours", "Restroom"],
//     ac: true,
//     music: true
//   }
];

const BADGES = {
  popular: { bg: "#FFF3CD", color: "#92400E", label: "🔥 Popular" },
  value: { bg: "#D1FAE5", color: "#065F46", label: "💎 Best Value" },
  top: { bg: "#FEE2E2", color: "#991B1B", label: "⭐ Top Pick" },
};

// Vehicle image mapping
const getVehicleImage = (vehicle) => {
  const map = { 
    sedan: sedan,
    premiumSedan: city,
    ertiga: ertiga,
    crysta: crysta,
    hycross: hycross,
    fortuner: fortuner,
    tempo: tempo,
    bus: bus,
    default: crysta 
  };
  return map[vehicle.image] || map.default;
};

// Vehicle Card Component
function VehicleCard({ v, onBook, onWhatsApp, index }) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const bc = v.badge ? BADGES[v.badge] : null;
  const imageUrl = getVehicleImage(v);

  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 24,
        overflow: "hidden",
        marginBottom: 16,
        boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
        border: "1.5px solid #F0F0F0",
        transition: "all 0.3s ease",
        animation: `fadeIn 0.4s ${index * 0.06}s ease both`,
      }}
    >
      <div style={{ display: "flex", flexDirection: window.innerWidth <= 768 ? "column" : "row" }}>
        {/* Image Section */}
        <div style={{
          position: "relative",
          width: window.innerWidth <= 768 ? "100%" : "280px",
          height: window.innerWidth <= 768 ? "180px" : "200px",
          background: "#f8f8f8",
          overflow: "hidden",
        }}>
          {!imageLoaded && (
            <div style={{
              position: "absolute",
              inset: 0,
              background: "linear-gradient(90deg, #f0f0f0 0%, #f8f8f8 50%, #f0f0f0 100%)",
              backgroundSize: "200% 100%",
              animation: "shimmer 1.5s infinite",
            }} />
          )}
          
          <img 
            src={imageUrl} 
            alt={v.name}
            onLoad={() => setImageLoaded(true)}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              objectPosition: "center",
              transition: "transform 0.5s ease",
              opacity: imageLoaded ? 1 : 0,
            }}
          />

          {bc && (
            <div style={{
              position: "absolute",
              top: 12,
              left: 12,
              background: bc.bg,
              borderRadius: 20,
              padding: "4px 12px",
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
              zIndex: 2,
            }}>
              <span style={{ fontSize: 11, fontWeight: 800, color: bc.color }}>
                {bc.label}
              </span>
            </div>
          )}

          <div style={{
            position: "absolute",
            top: 12,
            right: 12,
            background: "rgba(255,255,255,0.95)",
            borderRadius: 20,
            padding: "4px 10px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
            backdropFilter: "blur(4px)",
            zIndex: 2,
            display: "flex",
            alignItems: "center",
            gap: 4,
          }}>
            <Plane size={10} color={Y} />
            <span style={{ fontSize: 10, fontWeight: 700, color: "#1A1A1A" }}>
              Airport Transfer
            </span>
          </div>
        </div>

        {/* Content Section */}
        <div style={{ flex: 1, padding: "16px 20px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
            <div>
              <h3 style={{ fontSize: 18, fontWeight: 900, color: "#1A1A1A", margin: "0 0 4px" }}>
                {v.name}
              </h3>
              <p style={{ fontSize: 12, color: "#666", margin: 0 }}>
                {v.models} • {v.type}
              </p>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Star size={14} color={Y} fill={Y} />
              <span style={{ fontSize: 13, fontWeight: 700, color: "#1A1A1A" }}>{v.rating}</span>
            </div>
          </div>

          {/* Features Icons */}
          <div style={{ display: "flex", gap: 16, marginBottom: 12 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <Users size={14} color="#666" />
              <span style={{ fontSize: 12, color: "#666" }}>{v.seaters}+1</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <Luggage size={14} color="#666" />
              <span style={{ fontSize: 12, color: "#666" }}>{v.bags} bags</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <Wind size={14} color="#666" />
              <span style={{ fontSize: 12, color: "#666" }}>AC</span>
            </div>
          </div>

          {/* Price Card */}
          <div style={{
            background: "#F8F8F8",
            borderRadius: 16,
            padding: "12px 16px",
            marginBottom: 12,
            border: "1px solid #EEEEEE"
          }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <span style={{ fontSize: 20, fontWeight: 900, color: "#1A1A1A" }}>{v.price}</span>
                <span style={{ fontSize: 12, color: "#666", marginLeft: 4 }}>{v.HourPrice}</span>
                <span style={{ fontSize: 12, color: "#666", marginLeft: 4 }}> trip</span>
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                <span style={{ fontSize: 11, fontWeight: 600, color: YD, background: YL, padding: "3px 8px", borderRadius: 20 }}>
                  Free waiting
                </span>
                <span style={{ fontSize: 11, fontWeight: 600, color: YD, background: YL, padding: "3px 8px", borderRadius: 20 }}>
                  Flight tracking
                </span>
              </div>
            </div>
          </div>

          {/* Amenities */}
          <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 12 }}>
            {v.ac && <span style={{ fontSize: 11, background: "#F0F0F0", padding: "4px 10px", borderRadius: 20, display: "flex", alignItems: "center", gap: 4 }}><Wind size={12} /> AC</span>}
            {v.music && <span style={{ fontSize: 11, background: "#F0F0F0", padding: "4px 10px", borderRadius: 20, display: "flex", alignItems: "center", gap: 4 }}><Wifi size={12} /> Music</span>}
            {v.charger && <span style={{ fontSize: 11, background: "#F0F0F0", padding: "4px 10px", borderRadius: 20, display: "flex", alignItems: "center", gap: 4 }}><Battery size={12} /> Charger</span>}
            {v.wifi && <span style={{ fontSize: 11, background: "#F0F0F0", padding: "4px 10px", borderRadius: 20, display: "flex", alignItems: "center", gap: 4 }}><Wifi size={12} /> WiFi</span>}
            <span style={{ fontSize: 11, background: "#F0F0F0", padding: "4px 10px", borderRadius: 20, display: "flex", alignItems: "center", gap: 4 }}><Coffee size={12} /> Water bottle</span>
          </div>

          {/* Features List */}
          {expanded && (
            <div style={{ marginBottom: 12, animation: "slideDown 0.2s ease" }}>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                {v.features.map((f, fi) => (
                  <span key={fi} style={{ fontSize: 10, fontWeight: 600, color: YD, background: YL, padding: "3px 10px", borderRadius: 20 }}>
                    {f}
                  </span>
                ))}
              </div>
            </div>
          )}

          {/* Action Buttons */}
          <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
            <button
              onClick={() => onBook(v)}
              style={{
                flex: 1,
                background: Y,
                border: "none",
                color: "#1A1A1A",
                padding: "12px 0",
                borderRadius: 12,
                fontSize: 14,
                fontWeight: 800,
                cursor: "pointer",
                transition: "all 0.2s ease",
              }}
            >
              Book Now
            </button>
            <button
              onClick={() => onWhatsApp(v)}
              style={{
                width: 44,
                height: 44,
                background: "#25D366",
                border: "none",
                color: "#fff",
                borderRadius: 12,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 0.2s ease",
              }}
            >
              <FaWhatsapp size={20} />
            </button>
            <button
              onClick={() => setExpanded(!expanded)}
              style={{
                width: 44,
                height: 44,
                background: "#F0F0F0",
                border: "none",
                color: "#666",
                borderRadius: 12,
                cursor: "pointer",
                fontSize: 18,
                fontWeight: 600,
              }}
            >
              {expanded ? "−" : "+"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// Main Airport Transfer Page
export default function AirportTransfer() {
  const [isMobile, setIsMobile] = useState(false);
  const [sortBy, setSortBy] = useState('popular');
  const [vehicles, setVehicles] = useState(AIRPORT_VEHICLES);
  const navigate = useNavigate();

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    // Sort vehicles
    let sorted = [...AIRPORT_VEHICLES];
    if (sortBy === 'price-low') {
      sorted.sort((a, b) => parseInt(a.price.replace(/[^0-9]/g, '')) - parseInt(b.price.replace(/[^0-9]/g, '')));
    } else if (sortBy === 'price-high') {
      sorted.sort((a, b) => parseInt(b.price.replace(/[^0-9]/g, '')) - parseInt(a.price.replace(/[^0-9]/g, '')));
    } else if (sortBy === 'rating') {
      sorted.sort((a, b) => b.rating - a.rating);
    }
    setVehicles(sorted);
  }, [sortBy]);

  const handleBookNow = (vehicle) => {
    navigate('/booking', { 
      state: { 
        vehicle: vehicle,
        tripType: 'Airport Taxi'
      } 
    });
  };

  const handleWhatsApp = (vehicle) => {
    const phoneNumber = "919150410309";
    const message = `Hello! I'm interested in booking ${vehicle.name} for airport transfer.`;
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  const stats = [
    { icon: <Clock />, label: "24/7 Service", value: "Available" },
    { icon: <Shield />, label: "Safe Rides", value: "Verified" },
    { icon: <Users />, label: "Happy Customers", value: "10K+" },
  ];

  return (
    <div style={{ 
      minHeight: "100vh", 
      background: "#F5F5F5", 
      fontFamily: font,
      padding: isMobile ? "20px 16px 60px" : "40px 20px"
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800;900&display=swap');
        *{box-sizing:border-box;}
        @keyframes fadeIn{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}
        @keyframes shimmer{0%{background-position:-200% 0}100%{background-position:200% 0}}
        @keyframes slideDown{from{opacity:0;transform:translateY(-10px)}to{opacity:1;transform:translateY(0)}}
      `}</style>

      {/* Header */}
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div style={{ 
          display: "flex", 
          flexDirection: isMobile ? "column" : "row",
          justifyContent: "space-between",
          alignItems: isMobile ? "flex-start" : "center",
          marginBottom: 30
        }}>
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
              <div style={{ background: Y, borderRadius: 12, padding: 8 }}>
                <IoAirplaneOutline size={24} color="#1A1A1A" />
              </div>
              <h1 style={{ fontSize: isMobile ? 28 : 36, fontWeight: 900, color: "#1A1A1A", margin: 0 }}>
                Airport <span style={{ color: Y }}>Transfer</span>
              </h1>
            </div>
            <p style={{ fontSize: 14, color: "#666", maxWidth: 500 }}>
              Seamless airport pickups and drops with flight tracking and free waiting
            </p>
          </div>

          {/* Stats */}
          <div style={{ 
            display: "flex", 
            gap: 20,
            marginTop: isMobile ? 16 : 0
          }}>
            {stats.map((stat, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <div style={{ color: Y }}>{stat.icon}</div>
                <div>
                  <div style={{ fontSize: 12, color: "#666" }}>{stat.label}</div>
                  <div style={{ fontSize: 14, fontWeight: 800, color: "#1A1A1A" }}>{stat.value}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Features Banner */}
        <div style={{
          background: "linear-gradient(135deg, #28aa96 0%, #1e7467 100%)",
          borderRadius: 16,
          padding: "20px 24px",
          marginBottom: 30,
          display: "flex",
          flexWrap: "wrap",
          gap: 30,
          justifyContent: "space-between",
          alignItems: "center",
          color: "#fff"
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <MdOutlineFlight size={20} />
            <span style={{ fontSize: 14, fontWeight: 600 }}>Real-time flight tracking</span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Clock size={20} />
            <span style={{ fontSize: 14, fontWeight: 600 }}>60 mins free waiting</span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <MdOutlineLocalTaxi size={20} />
            <span style={{ fontSize: 14, fontWeight: 600 }}>Meet & greet service</span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Shield size={20} />
            <span style={{ fontSize: 14, fontWeight: 600 }}>Sanitized cabs</span>
          </div>
        </div>

        {/* Sort Bar */}
        <div style={{ 
          display: "flex", 
          justifyContent: "space-between", 
          alignItems: "center",
          marginBottom: 20
        }}>
          <div>
            <span style={{ fontSize: 14, color: "#666" }}>Showing {vehicles.length} vehicles</span>
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <select 
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              style={{
                padding: "8px 16px",
                borderRadius: 30,
                border: "1px solid #E0E0E0",
                background: "#fff",
                fontSize: 13,
                fontWeight: 500,
                outline: "none"
              }}
            >
              <option value="popular">Popular</option>
              <option value="price-low">Price: Low to High</option>
              <option value="price-high">Price: High to Low</option>
              <option value="rating">Rating</option>
            </select>
          </div>
        </div>

        {/* Vehicle List */}
        <div>
          {vehicles.map((vehicle, index) => (
            <VehicleCard
              key={vehicle.id}
              v={vehicle}
              index={index}
              onBook={handleBookNow}
              onWhatsApp={handleWhatsApp}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
